import { MetalPrices } from '../types';

// Cache for monthly price files
const monthlyCache: { [key: string]: MetalPrices } = {};

// Load prices for a specific month
const loadMonthlyPrices = async (yearMonth: string): Promise<MetalPrices> => {
  if (monthlyCache[yearMonth]) return monthlyCache[yearMonth];
  
  try {
    const response = await fetch(`/data/prices/${yearMonth}.json`);
    if (!response.ok) throw new Error('Month file not found');
    const data = await response.json();
    
    // Handle both formats
    let prices: MetalPrices;
    if (Array.isArray(data)) {
      // New format: array of records
      prices = {};
      data.forEach((record: any) => {
        prices[record.date] = {
          gold: record.gold_price_per_gram,
          silver: record.silver_price_per_gram
        };
      });
    } else {
      // Old format: object with dates as keys
      prices = data;
    }
    
    monthlyCache[yearMonth] = prices;
    return prices;
  } catch (error) {
    console.error(`Failed to load prices for ${yearMonth}:`, error);
    return {};
  }
};

// Get price for a specific date
export const getPriceForDate = async (date: string): Promise<{ gold: number; silver: number } | null> => {
  const [year, month] = date.split('-');
  const yearMonth = `${year}-${month}`;
  
  const monthPrices = await loadMonthlyPrices(yearMonth);
  return monthPrices[date] || null;
};

// Get the latest available date by checking the index file
export const getLatestDate = async (): Promise<string> => {
  try {
    const response = await fetch('/data/prices/index.json');
    const index = await response.json();
    return index.latestDate;
  } catch (error) {
    console.error('Failed to load price index:', error);
    // Fallback to current date
    return new Date().toISOString().split('T')[0];
  }
};

export const getMinDate = (): string => '1982-07-01';
